import { Result } from '../../../common-models/Result';
import { HttpServiceBase } from '../../../common-services/Http/HttpServiceBase';
import { GetDetailedStatusForOrderRecipeLinkingInput } from './GetDetailedStatusForOrderRecipeLinkingInput';
import { GetDetailedStatusForOrderRecipeLinkingOutput } from './GetDetailedStatusForOrderRecipeLinkingOutput';

export class GetDetailedStatusForOrderRecipeLinkingService extends HttpServiceBase {

  handle = (input?: GetDetailedStatusForOrderRecipeLinkingInput): Promise<Result<GetDetailedStatusForOrderRecipeLinkingOutput> | null> => {
    const parameters = input ? this.objectToUrl(input) : '';
    const promise = this.http.get<Result<GetDetailedStatusForOrderRecipeLinkingOutput>>(`${this.baseUrlSislogApi}/v2/recipe-by-product/detailed-status-for-order-recipe-linking${parameters}`);
    return promise;
  }
}